module.exports = {
  label: 'Информация о специальных грузах',
  CLASSNO: 'Класс опасного груза (CLASS NO)',
  UNNO: 'Номер ООН',
  PACKING: 'Категория упаковки груза',
  EMS: 'Аварийная карта (Emergency Schedule)',
  Point: 'Температура вспышки',
  Isolation: 'Изоляция',
  man24: 'Круглосуточный экстренный контакт',
  tel24: 'Телефонный номер',
  ResponsibleParty: 'Ответственная сторона',
  HSCODE: 'Код HS',
  ContractNbr: 'Номер контракта',
  SHIPPER: 'Габариты (Д×Ш×В)',
  PickTime: 'Время забора контейнера',
  SeaPullution: 'Загрязнение моря',
  GOH: 'Контейнер для одежды',
  Tier: 'Ярус',
  Hanger: 'Количество штук на ярус',
  Ropes: 'Количество тросов в трубке',
  Knots: 'Количество узлов на тросе',
  ReformCost: 'Стоимость переделки',
  Warehouse: 'Склад приёмки',
  Reefer: 'Рефрижераторный контейнер',
  humidity: 'Влажность (%)',
  ventilation: 'Объём вентиляции (м³)',
  Business: 'Требуется ли товароведческая экспертиза',
  PTI: 'Дни предварительного охлаждения',
  ContainerYard: 'Пункт погрузки контейнера',
  Address: 'Информация о пункте доставки',
  StuffingTime: 'Время упаковки',
  DeliverTime: 'Портовая зона доставки контейнера',
  WarehousingTime: 'Дата приёмки на склад',
  DoccutoffTime: 'Крайний срок подачи документов',
  CustomsCutoffTime: 'Дата закрытия таможни',
  CorrectTransportName: 'Правильное транспортное наименование',
  SecondarySpecialGoods: 'Дополнительный класс опасности',
  GrossWeight: 'Брутто-вес',
  NeatWeight: 'Нетто-вес',
  OuterPackagingType: 'Тип внешней упаковки',
  OuterPackagingQuantity: 'Количество внешней упаковки',
  InnerPackagingType: 'Тип внутренней упаковки',
  InnerPackagingQuantity: 'Количество внутренней упаковки',
  Remark: 'Примечание',
  Add: 'Добавить',
  Delete: 'Удалить',
  PackingCode: 'Код упаковки',
  Import: 'Импорт',
  FillIn: 'Связь',
  OnlyEnterYN: 'Допустим ввод только Y или N',
  ThisFieldRequired: 'Если тип внешней упаковки 4G, это поле обязательно',
  HumidityToolTip: 'Влажность = процент влажности в воздухе',
  Temp: 'Температура',
  VentilationWse: 'Объем вентиляции',
  VgmWeight: 'Вес VGM (Verified Gross Mass)',
  dgContactEmail: 'Электронная почта контактного лица по опасным грузам',
  dgContactFax: 'Факс контактного лица по опасным грузам',
  bookingNo: 'Номер бронирования перевозки',
  TemperatureUnit: 'Единица измерения температуры'
}
